import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  variant?: 'poster' | 'landscape';
}

export default function MovieCard({ movie, variant = 'poster' }: MovieCardProps) {
  if (variant === 'landscape') {
    return (
      <Link
        to={`/article/${movie.id}`}
        className="group block cursor-pointer"
      >
        <div className="relative overflow-hidden rounded-lg aspect-video bg-background-100">
          <img
            src={movie.posterImage}
            alt={movie.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="text-foreground-950 font-semibold text-sm md:text-base mb-1">
              {movie.title}
            </h3>
            <div className="flex items-center gap-2 text-xs text-foreground-300">
              <span className="flex items-center gap-1">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                {movie.rating}
              </span>
              <span>{movie.year}</span>
              <span>{movie.episodeCount}</span>
            </div>
          </div>
          {movie.isVip && (
            <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-950 text-xs font-semibold rounded-md">
              VIP
            </div>
          )}
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[2/3] relative">
          <img
            src={movie.coverImage}
            alt={movie.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

          {movie.isHot && (
            <div className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-semibold rounded-md">
              热门
            </div>
          )}
          {movie.isNew && !movie.isHot && (
            <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-950 text-xs font-semibold rounded-md">
              新上
            </div>
          )}
          {movie.isVip && (
            <div className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500/90 text-background-950 text-xs font-semibold rounded-md">
              VIP
            </div>
          )}
        </div>

        <div className="p-3">
          <h3 className="text-foreground-950 text-sm font-medium truncate mb-1">
            {movie.title}
          </h3>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              <span className="text-accent-500 text-xs font-semibold">{movie.rating}</span>
            </div>
            <span className="text-foreground-400 text-xs">{movie.category}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}